(function () {
  function toast(msg) {
    var t = document.getElementById('pp-home-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'pp-home-toast';
      t.style.cssText = 'position:fixed;bottom:24px;right:24px;z-index:10000;background:#161719;color:#f7f8f0;border-radius:999px;padding:12px 18px;font:500 13px Inter,system-ui,sans-serif;box-shadow:0 8px 30px rgba(0,0,0,.18);opacity:0;transform:translateY(8px);transition:all .25s;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'none'; });
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateY(8px)'; }, 2200);
  }

  function add(vid, btn) {
    if (!vid || !window.fetch) return;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Bezig...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble,header', sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (added) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'pp-home', data: { source: 'product-form-component', itemCount: cart.item_count, sections: added.sections || {} } } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          toast('Toegevoegd aan winkelwagen');
          if (btn) { btn.disabled = false; btn.textContent = 'Toegevoegd'; setTimeout(function () { btn.textContent = label; }, 1500); }
        });
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } toast('Er ging iets mis'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pp-add]');
    if (b) { e.preventDefault(); add(b.getAttribute('data-pp-add'), b); }
  });
})();
